import {defineSlotRecipe} from '@chakra-ui/react3'

export const campaignSlotRecipe = defineSlotRecipe({
    className: 'campaign',
    slots: [
        'moduleContainer',
        'flexContainer',
        'flexItemText',
        'flexItemImage',
        'copy',
        'buttonContainer',
        'headingCopyContainer'
    ],

    base: {
        moduleContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: {base: 'spacing-40', s: 'spacing-80'}
        },
        flexContainer: {
            flexDirection: {base: 'column-reverse', s: 'row'},
            gap: {base: 'spacing-32', s: 'spacing-16'}
        },
        headingCopyContainer: {
            flexDirection: 'column',
            gap: 'spacing-16'
        },
        flexItemText: {
            flex: 1,
            borderRadius: 's',
            flexDirection: 'column'
        },
        flexItemImage: {
            flex: 1,
            borderRadius: 's',
            overflow: 'hidden'
        },
        buttonContainer: {
            paddingTop: {base: 'spacing-24', s: 'spacing-40'},
            gap: 'spacing-8',
            alignSelf: 'flex-start'
        }
    },

    variants: {
        imageAlignment: {
            right: {
                flexContainer: {
                    flexDirection: {base: 'column-reverse', s: 'row'}
                }
            },
            left: {
                flexContainer: {
                    flexDirection: {base: 'column-reverse', s: 'row-reverse'}
                }
            }
        },
        textBackground: {
            true: {
                flexContainer: {
                    gap: 'spacing-16'
                },
                flexItemText: {
                    backgroundColor: 'var(--module-surface-bg-color)',
                    paddingY: {base: 'spacing-40', s: 'spacing-90'},
                    paddingX: {base: 'spacing-16', s: 'spacing-90'}
                }
            },
            false: {
                flexItemText: {
                    backgroundColor: 'transparent'
                },
                headingCopyContainer: {
                    maxWidth: {s: '25.5625rem'},
                    marginLeft: 'auto',
                    marginRight: 'auto'
                },
                buttonContainer: {
                    maxWidth: {s: '25.5625rem'},
                    width: {s: '25.5625rem'},
                    marginLeft: 'auto',
                    marginRight: 'auto'
                }
            }
        },
        textAlignment: {
            center: {
                flexContainer: {
                    alignItems: 'center'
                }
            },
            top: {
                flexContainer: {
                    alignItems: 'start'
                }
            }
        },
        aspectRatio: {
            '16/10': {
                flexItemImage: {
                    minHeight: {base: '204px', s: 'auto'}
                }
            },
            '4/3': {
                flexItemImage: {
                    minHeight: {base: '245px', s: 'auto'}
                }
            },
            '1/1': {
                flexItemImage: {
                    minHeight: {base: '327px', s: 'auto'}
                }
            }
        }
    },

    defaultVariants: {
        aspectRatio: '16/10',
        imageAlignment: 'right',
        textBackground: false,
        textAlignment: 'center'
    }
})
